/**
 * @enum {string}
 * @readonly
 */
export const OrbisResourceType = {
  ASSET: 'assets',
  BANNER: 'banners',
  STATION: 'epg/stations',
  SHOW: 'shows',
  SEASON: 'seasons',

  LIVE_COMPETITION: 'epg/competitions',
  LIVE_EPISODE: 'epg/episodes',
  LIVE_EVENT: 'epg/events',
  LIVE_MOVIE: 'epg/movies',
  LIVE_TEAM_COMPETITION: 'epg/teamCompetitions',

  VOD_COMPETITION: 'vod/competitions',
  VOD_EPISODE: 'vod/episodes',
  VOD_EVENT: 'vod/events',
  VOD_MOVIE: 'vod/movies',
  VOD_TEAM_COMPETITION: 'vod/teamCompetitions',
};

/**
 * @enum {string}
 * @readonly
 */
export const BlimResourceType = {
  SHOW: 'SHOW',
  MOVIE: 'MOVIE',
  EPISODE: 'EPISODE',
  SERIE: 'SERIE',
  LIVE_MOVIE: 'LIVE_MOVIE',
  LIVE_EPISODE: 'LIVE_EPISODE',
  LIVE_SERIE: 'LIVE_SERIE',
};

/**
 * @enum {string}
 * @readonly
 */
export const PageType = {
  HOME: 'HOME',
  VOD: 'VOD',
  SPORTS: 'SPORTS',
  LIVE: 'LIVE',
  KIDS: 'KIDS',
  BLIM: 'BLIM',
  SEARCH: 'SEARCH',
};

/**
 * @enum {string}
 * @readonly
 */
export const ContentType = {
  LIVE: 'EPG',
  VOD: 'VOD',
};

/**
 * @enum {string}
 * @readonly
 */
export const StationCategory = {
  SPORTS: 1,
  KIDS: 2,
  LOCAL_AND_NEWS: 3,
  MOVIES: 4,
  SERIES_AND_SHOWS: 5,
};

export const MILLISECONDS_IN_A_SECOND = 1000;
export const SECONDS_IN_A_MINUTE = 60;
export const MINUTES_IN_AN_HOUR = 60;
export const HOURS_IN_A_DAY = 24;

export const DEFAULT_FORMAT_TIME_TEXTS = {
  texts: {
    startsAt: 'Comienza en',
    endsIn: 'Termina en',
  },
  time: {
    day: {
      today: 'Hoy',
      tomorrow: 'Mañana',
    },
    hours: {
      singular: 'h',
      plural: 'hs',
    },
    minutes: 'min',
  },
};
